import { ApiResponse, TokenData, IBank, District } from '../models';
import * as http from './http';
import ApiService from './service';

export class DistrictService extends ApiService {
  public async loadAllDistricts(): Promise<District[]> {
    const url = `${this.apiDomain}/api/district/list`;
    const resposne = await http.get<ApiResponse<District[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async updateDistrict(data: District, id?: string) {
    const url = `${this.apiDomain}/api/district/${id}`;
    const response = await http.put<ApiResponse<District>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createDistrict(data: District) {
    const url = `${this.apiDomain}/api/district`;

    const response = await http.post<ApiResponse<District>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteDistrict(id?: string) {
    const url = `${this.apiDomain}/api/district/${id}`;

    const response = await http.remove<ApiResponse<District>>(url, this.store);
    return response.data;
  }
}
